import {
  EDITING_DOCUMENT__SUBMIT_FAILURE,
  EDITING_DOCUMENT__SUBMIT_REQUEST,
  EDITING_DOCUMENT__SUBMIT_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

type EditingDocumentIsInsertingState = boolean;

const initialState: EditingDocumentIsInsertingState = false;

export default function reducer(
  state: EditingDocumentIsInsertingState = initialState,
  action: EditingDocumentAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__SUBMIT_REQUEST:
      return true;
    case EDITING_DOCUMENT__SUBMIT_SUCCESS:
    case EDITING_DOCUMENT__SUBMIT_FAILURE:
      return false;
    default:
      return state;
  }
}
